module.exports = __webpack_public_path__ + "img/red-desert-decal-08.09e6e1a2.png";